import { formReducer } from './form-reducer';
import { optionsReducer } from './options-reducer';
import { tritonReducer } from './triton-reducer';
import { uiReducer } from './ui-reducer';
import { flexReducer } from './flex-reducer';
import { echoReducer } from './echo-reducer';
import { foresiteXdReducer } from './foresite-xd-reducer';

export function reducer(state, action) {
    // Apply each reducer in sequence
    state = formReducer(state, action);
    state = optionsReducer(state, action);
    state = tritonReducer(state, action);
    state = flexReducer(state, action);
    state = uiReducer(state, action);
    state = echoReducer(state, action);
    state = foresiteXdReducer(state, action);

    return state;
}

export * from './state';